/* eslint-disable complexity */
/* eslint-disable max-lines */
/* eslint-disable max-lines-per-function */
// eslint-disable-next-line max-lines-per-function
import { BReactComponent } from 'blocks-cloud/b-react-component';
import { getDownloadDropdownList } from 'Cloud/Application/Editor/MyOffice/myOffice.helpers';
import { EditorID } from 'Cloud/Application/Editor/types';
import features from 'Cloud/Application/Features';
import { Promo } from 'Cloud/Application/Promo';
import { promoController } from 'Cloud/Application/PromoController';
import { callApiR7Convert } from 'Cloud/Application/r7helpers';
import { isClientEditorError, R7Theme } from 'Cloud/Application/types';
import { openPopup, openTab as _openTab } from 'Cloud/Application/Window';
import browser from 'Cloud/browser';
import { epsilonTime } from 'lib/epsilonTime';
import { extInfo } from 'lib/extInfo';
import { logger } from 'lib/logger';
import { addParams } from 'lib/urlUtils';
import { xray } from 'lib/xray';
import { clone } from 'ramda';
import { type WopiData, WopiProvider } from 'reactApp/api/wopi/WopiAPI.types';
import { getDomainRestrictionsForItems } from 'reactApp/appHelpers/appHelpers';
import {
    CHOSEN_EDITOR,
    EDITORS_CONFIG,
    IS_B2B_BIZ_USER,
    IS_FREE_B2B_BIZ_EDITORS_USER,
    IS_FREE_BIZ_SAAS_USER,
    IS_MOBILE_BROWSER,
    IS_MY_TEAM,
    IS_OWN_PUBLIC,
    IS_PUBLIC,
    IS_STOCK,
    IS_TABLET_BROWSER,
    platform,
    VIEWERS_CONFIG,
} from 'reactApp/appHelpers/configHelpers';
import { emitAnalyticEvent } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';
import { isRebranding } from 'reactApp/appHelpers/featuresHelpers';
import { allowEditForOwner } from 'reactApp/appHelpers/featuresHelpers/features/allowEditForOwner';
import { IS_EDITORS_CONSISTENCY_ENABLED } from 'reactApp/appHelpers/featuresHelpers/features/editorsConsistency';
import { GET_CHOSEN_EDITOR_FROM_LIST } from 'reactApp/appHelpers/featuresHelpers/features/getChosenEditorFromList';
import { R7_FOR_EDITING_ATTACHES } from 'reactApp/appHelpers/featuresHelpers/features/r7ForEditingAttaches';
import { USE_EDITOR_MODE_FROM_REQUEST_PARAMS } from 'reactApp/appHelpers/featuresHelpers/features/useEditorModeFromRequestParams';
import {
    clearNotificationAboutCreatingCopyOfNoneditableFile,
    getNotificationAboutCreatingCopyOfNoneditableFile,
    NotifyFrom,
} from 'reactApp/appHelpers/notificationAboutCreatingCopyOfNoneditableFile';
import { publishHelper } from 'reactApp/appHelpers/publishHelper';
import { getRequestParamEditorMode, isDesktopR7App } from 'reactApp/appHelpers/settingsHelpers';
import { toolbarActions } from 'reactApp/appHelpers/toolbarActions';
import {
    renderBizPaidEditorDialog,
    renderComfirmationDialog,
    renderMessageBox,
} from 'reactApp/components/BaseConfirmDialog/BaseConfirmDialog.helpers';
import { isCreateDocumentQueryAction } from 'reactApp/components/CreateDocumentByLinkDialog/createDocumentByLinkDialog.type';
import { renderNewDocumentModal } from 'reactApp/components/NewDocumentModal/NewDocumentModal.helpers';
import { renderOpenDocument } from 'reactApp/components/OpenDocument/openDocument.toolkit';
import { r7StageCB } from 'reactApp/hooks/useR7Stage';
import { setRebranding } from 'reactApp/hooks/useRebranding';
import { isAvailableInDocumentSection } from 'reactApp/modules/allDocuments/allDocuments.helpers.store';
import { composeAvailableEditors, composeExtensions, composeSharedExtensions } from 'reactApp/modules/editor/editor.helpers';
import { startEditor } from 'reactApp/modules/editor/editor.module';
import { getEditorsByExtension } from 'reactApp/modules/editor/editor.selectors';
import { EditorRestrictionsSelectors } from 'reactApp/modules/editorRestrictions/editorRestrictions.selectors';
import { inlineHeader, isOnPremR7Product, LLM } from 'reactApp/modules/features/features.helpers';
import { getAstraMetaFeature, getFeatureMyOfficeSendDetailRadars } from 'reactApp/modules/features/features.selectors';
import { canOpenSmallFile } from 'reactApp/modules/file/helpers/canOpenSmallFile';
import { checkFolderForUpdate, makeNewDocumentError, makeNewDocumentSuccess } from 'reactApp/modules/modifying/modifying.actions';
import { editAttachCopyNotification, editPublicCopyNotification } from 'reactApp/modules/modifying/modifying.helpers';
import { routeStatusPage } from 'reactApp/modules/router/router.module';
import { getCurrentRouteId, getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { SettingsSelectors } from 'reactApp/modules/settings/settings.selectors';
import { snackbarController } from 'reactApp/modules/snackbar/snackbar.controller';
import { SnackbarTypes } from 'reactApp/modules/snackbar/snackbar.types';
import { isEditorStorage } from 'reactApp/modules/storage/storage.helpers';
import {
    getCurrentFolder,
    getItemById,
    hasParentMountedOrSharedFolder,
    isMountedOrSharedFolder,
} from 'reactApp/modules/storage/storage.selectors';
import { type CloudFile, EStorageType } from 'reactApp/modules/storage/storage.types';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { ViewerSelectors } from 'reactApp/modules/viewer/viewer.selectors';
import { EStatus } from 'reactApp/sections/ErrorPage/ErrorPage.types';
import { store as reduxStore } from 'reactApp/store';
import { openDisabledFeaturePopupHelper } from 'reactApp/ui/DisabledFeatureDialog/DisabledFeatureDialog.helpers';
import { DisabledFeature } from 'reactApp/ui/DisabledFeatureDialog/DisabledFeatureDialog.types';
import { BizInlineEditorToolbar } from 'reactApp/ui/EditorHeader/BizInlineEditorToolbar/BizInlineEditorToolbar';
import { EditorHeaderContainer as EditorHeader } from 'reactApp/ui/EditorHeader/EditorHeaderContainer';
import { InlineEditorToolbar } from 'reactApp/ui/EditorHeader/InlineEditorToolbar/InlineEditorToolbar';
import { MyTeamMobileEditorHeader } from 'reactApp/ui/EditorHeader/MyTeamMobileEditorHeader/MyTeamMobileEditorHeader';
import { EditorLLMButton } from 'reactApp/ui/EditorLLM/EditorLLMButton/EditorLLMButton';
import { EditorLlmDialog } from 'reactApp/ui/EditorLLM/EditorLLMDialog/EditorLlmDialog';
import { SCENARIO_SELECT_OPTIONS } from 'reactApp/ui/EditorLLM/EditorLLMDialog/utils/EditorLlmDialog.utils';
import { llmFeature } from 'reactApp/ui/EditorLLM/helpers/EditorLlmHelpers';
import { MobileDialog } from 'reactApp/ui/Mobile/MobileDialog/MobileDialog';
import { sendViewerDwh } from 'reactApp/ui/ReactViewer/ReactViewer.helpers';
import { sessionWatcher } from 'reactApp/ui/ReactViewer/SessionWatcher';
import { AstraMetaProcessorType, createAstraMetaDiv } from 'reactApp/utils/astraPluginHelpers';
import { sendCounter } from 'reactApp/utils/counter';
import {
    callR7EditorsConsistencySupportAPICall,
    callWopiEditorsConsistencySupportAPICall,
} from 'reactApp/utils/editorsСonsistencySupportHelpers';
import { sendXray } from 'reactApp/utils/ga';
import { isEnabledMultiWindow, openNewWindow } from 'reactApp/utils/multiWindow';
import { isDarkThemeModeEnabled } from 'reactApp/utils/theme';
import { captureException } from 'reactApp/utils/tracer';
import { callWopiEditAPICall } from 'reactApp/utils/wopiHelpers';
import { calculateMaxEditableOrPreviewableSizeForEditor } from 'server/helpers/editors/calculateMaxEditableOrPreviewableSizeForEditor';
import { getEditorsConfig } from 'server/helpers/editors/getEditorsConfig';
import { sortEditors } from 'server/helpers/editors/sortEditors';
import { type ServerEditor, EditorMode } from 'server/helpers/editors/types';

import { BUBBLE_ID, OFFICE_EDITOR, X_IN_SHARED_FOLDER } from './Editor/config';
import {
    callApiCreateDoc,
    createWindowName,
    getCloudUrl,
    getExt,
    getIsOpenDocumentWarning,
    getV2orUniqueIdUrl,
    isOpenedTab,
    joinPath,
    setIsOpenDocumentWarning,
    shortenFilename,
} from './Editor/helpers';
import { addEditorMessageListener, logEditorOpenError, startEditorSuccessWaiter } from './EditorStatistics';
import { user } from './User';

let isEnabledBubble = false;
let tabs = {};

// CLOUDWEB-5491, CLOUDWEB-5602, CLOUDWEB-5605, CLOUDWEB-5606

let tabGCTimeoutId = 0;

const startTabGC = () => {
    window.clearTimeout(tabGCTimeoutId);

    Object.keys(tabs).forEach(function (tabName) {
        if (!isOpenedTab(tabs[tabName])) {
            // затираем ссылку на вкладку тк с помощью delete она не удаляется
            tabs[tabName] = null;
            delete tabs[tabName];
        }
    });

    tabGCTimeoutId = window.setTimeout(startTabGC, 60000);
};

export const editors: ServerEditor[] = (EDITORS_CONFIG?.length ? EDITORS_CONFIG : VIEWERS_CONFIG).sort(sortEditors);

const HAS_SHARED_EDITOR = editors.some((editor) => X_IN_SHARED_FOLDER in editor);

const DETAILED_RADARS = features().getFeatureParam('detailedRadars', 'editor', false);
const current = CHOSEN_EDITOR || {};

const extensions = composeExtensions(editors);
const editorsMap = composeAvailableEditors(editors, extensions);
const sharedExtensions = composeSharedExtensions(editors, extensions);

const getByExt = (item: any) => extensions[getExt(item)] || { editors: [] };

const EDITOR_ID_MAP: Record<WopiProvider.R7_WOPI | WopiProvider.MYOFFICE, EditorID.R7_WOPI | EditorID.MYOFFICE> = {
    [WopiProvider.R7_WOPI]: EditorID.R7_WOPI,
    [WopiProvider.MYOFFICE]: EditorID.MYOFFICE,
};

const flipObject = <Key extends PropertyKey, Value extends PropertyKey>(object: Record<Key, Value>): Record<Value, Key> =>
    Object.keys(object).reduce((ret, key) => {
        ret[object[key]] = key;
        return ret;
    }, {} as Record<Value, Key>);

const AVAILABLE_PROVIDER_ID_MAP = flipObject(EDITOR_ID_MAP);

enum EditorStatus {
    Ready = 'Ready',
    Error = 'Error',
}

const getEditorData = async (
    id: string
): Promise<{ status: EditorStatus.Ready; data: WopiData } | { status: EditorStatus.Error; data: EditorID | null }> => {
    try {
        const { data } = await callWopiEditAPICall(id, current.id);

        return { status: EditorStatus.Ready, data };
    } catch (error: unknown) {
        if (isClientEditorError(error)) {
            const providerId = error.response.fields[1] || '';
            return { status: EditorStatus.Error, data: EDITOR_ID_MAP[providerId] };
        }

        return { status: EditorStatus.Error, data: null };
    }
};

const getEditorOverride = async (
    id: string,
    mode: string,
    currentEditor: EditorID
): Promise<EditorID.R7 | EditorID.MYOFFICE | undefined> => {
    if (!IS_EDITORS_CONSISTENCY_ENABLED || mode !== 'edit' || IS_B2B_BIZ_USER) {
        return;
    }

    try {
        if (currentEditor === EditorID.MYOFFICE || currentEditor === EditorID.R7_WOPI) {
            // Проверка есть ли другая сессия документа на Р7
            const result = await callR7EditorsConsistencySupportAPICall(id);
            sendXray(['edtr', 'actv', 'res', 'r7'], {
                [result?.data?.has_sessions ? 'has' : 'no_has']: 1,
            });
            if (result?.data?.has_sessions) {
                return EditorID.R7;
            }
            return;
        }

        if (currentEditor === EditorID.R7) {
            // Есть ли сессии внутри wopi?
            const result = await callWopiEditorsConsistencySupportAPICall(id);
            sendXray(['edtr', 'actv', 'res', 'wopi'], {
                [result?.data?.has_sessions ? 'has' : 'no_has']: 1,
            });
            if (result?.data?.has_sessions) {
                return EditorID.MYOFFICE;
            }
        }
    } catch (err: any) {
        const status = 'status' in err ? `status_${err.status}` : 'status_nan';
        sendXray(['edtr', 'actv', 'err', currentEditor === EditorID.R7 ? 'wopi' : 'r7'], {
            [status]: 1,
        });
        return;
    }
};

const editor = {
    isEditor() {
        return current && current.id && editorsMap[current.id];
    },

    getDefaultEditorId(item, isCreate) {
        const ext = getExt(item);
        const state = reduxStore.getState();
        const hasSharedEditor = HAS_SHARED_EDITOR && sharedExtensions[ext];
        const isSharedOrMountedState = isMountedOrSharedFolder(state, isCreate ? getCurrentFolder(state) : item).is;
        const isSharedFolder = hasSharedEditor && isSharedOrMountedState;
        const editors = getEditorsByExtension(state, ext);
        const serverEditors = editors.map((editorId) => editorsMap[editorId]);

        if (hasSharedEditor && isSharedFolder) {
            return serverEditors.find((serverEditor) => {
                return serverEditor.default === 'shared-folder';
            })?.id;
        }

        let availableEditors = serverEditors.sort(sortEditors);

        if (!R7_FOR_EDITING_ATTACHES) {
            const isAttach =
                typeof item === 'object' && 'storage' in item
                    ? item.storage === EStorageType.attaches || item.storage === EStorageType.viewerAttaches
                    : false;
            if (isAttach) {
                availableEditors = availableEditors.filter((editor) => editor.id !== EditorID.R7 && editor.id !== EditorID.R7_WOPI);
            }
        }

        return availableEditors.length ? availableEditors[0]?.id : undefined;
    },

    getEditorsFor(item) {
        const result: any[] = [];

        if (!item) {
            return result;
        }

        if (!canOpenSmallFile(item)) {
            // для файлов размером меньше 21 байта просмотр недоступен
            return result;
        }

        const editorsByExt = getByExt(item).editors;

        const extData = extInfo.get(item.ext);
        const maxSize = calculateMaxEditableOrPreviewableSizeForEditor(
            current.id || (GET_CHOSEN_EDITOR_FROM_LIST && editorsByExt[0] ? editorsByExt[0] : 'default'),
            extData.maxEditableSize
        );

        if (!maxSize || item.size > maxSize) {
            return result;
        }

        const state = reduxStore.getState();

        let isSharedFolder = false;
        const hasSharedEditor = HAS_SHARED_EDITOR && sharedExtensions[getExt(item)];
        if (hasSharedEditor) {
            isSharedFolder = isMountedOrSharedFolder(state, item).is;
        }

        const storage = getCurrentStorage(state);

        if (
            item.storage !== EStorageType.home &&
            item.storage !== EStorageType.feed &&
            item.storage !== EStorageType.alldocuments &&
            item.storage !== EStorageType.templates &&
            item.storage !== EStorageType.public &&
            item.storage !== EStorageType.sharedLinks &&
            !isEditorStorage(storage || item.storage)
        ) {
            return result;
        }

        editorsByExt.forEach((id) => {
            let editor = editorsMap[id];
            const isDefault = hasSharedEditor && isSharedFolder ? editor.default === 'shared-folder' : !!editor.default;

            if (!hasSharedEditor || !editor[X_IN_SHARED_FOLDER] || isSharedFolder) {
                editor = Object.assign(
                    {},
                    editor,
                    {
                        icon: editor.icon ? editor.icon[item.ext] : undefined,
                        icon_big: editor?.icon_big?.[item.ext],
                    },
                    {
                        name: editor.id,
                        text: editor.title,
                    }
                );

                if (isDefault) {
                    // default is always first
                    result.unshift(editor);
                } else {
                    result.push(editor);
                }
            }
        });

        return result;
    },

    openEditor(item, editorId) {
        const state = reduxStore.getState();
        const isCorpUser = UserSelectors.isCorpUser(state);
        if (user.isOverquota() && !isCorpUser) {
            openDisabledFeaturePopupHelper({ disabledFeature: DisabledFeature.newFile });
            return;
        }
        if (!editorId) {
            editorId = this.getDefaultEditorId(item, false);
        }
        openEditor(editorsMap[editorId], item);
    },

    createNew(ext, editorId, currentFolder, from) {
        if (!editorId) {
            editorId = this.getDefaultEditorId(ext, true);
        }

        if (IS_FREE_B2B_BIZ_EDITORS_USER && !editorId) {
            renderBizPaidEditorDialog();
            return;
        }

        if (editorId === EditorID.R7_WOPI || editorId === EditorID.R7) {
            renderNewDocumentModal({ createDocument: openEditor, editorArg: editorsMap[editorId], item: { id: currentFolder }, ext, from });
            return;
        }

        openEditor(editorsMap[editorId], { id: currentFolder }, ext);
    },

    clearWindowName() {
        // CLOUDWEB-6848
        // Необходимо очищать window.name после загрузки Облака
        // в окне редактора, чтобы разрешить повторное редактирование.
        if (!editor.isEditor()) {
            const defaultWindowName = '';
            const currentWindowName = window.name || defaultWindowName;
            const editor = editors.find(function (editor) {
                return currentWindowName.indexOf(`${editor.id}_`) === 0;
            });

            if (editor) {
                window.name = defaultWindowName;

                const radar = RADAR.group('app_clear-win-name');

                radar.add(String(editor.id).toLowerCase());
                radar.add('all');
                radar.send();

                return true;
            }
        }

        return false;
    },

    // eslint-disable-next-line sonarjs/cognitive-complexity
    start: async (item) => {
        sessionWatcher.init();

        const state = reduxStore.getState();

        const enabledEditors: { id: EditorID; wopi?: boolean }[] = [...editors];

        if (!current.id) {
            // Информации о редакторе не будет, если мы открываем файл внутри паблик папки с правами на редактирование.
            // Подбираем подходящий редактор и пробуем открыться в нем
            const editorFor = editor.getEditorsFor(item);
            current.id = editorFor[0]?.id;
            current.data = getEditorsConfig(current.id);
            current.mode = item.weblinkAccessRights === 'rw' ? EditorMode.EDIT : EditorMode.VIEW;
        }

        const editingRestricted = EditorRestrictionsSelectors.isEditingRestricted(state);

        const modeFromRequestParams = getRequestParamEditorMode();

        if (modeFromRequestParams && USE_EDITOR_MODE_FROM_REQUEST_PARAMS) {
            current.mode = modeFromRequestParams;
        } else if (editingRestricted || (IS_FREE_BIZ_SAAS_USER && IS_OWN_PUBLIC)) {
            current.mode = EditorMode.VIEW;
        } else if (allowEditForOwner && IS_OWN_PUBLIC) {
            current.mode = EditorMode.EDIT;
        } else if (item.mode === 'comment') {
            current.mode = EditorMode.COMMENT;
        }

        const editorOverride = await getEditorOverride(item.id, current.mode, current.id);
        if (editorOverride) {
            current.id = editorOverride;
            enabledEditors.push({ id: editorOverride, wopi: editorOverride === EditorID.MYOFFICE });
        }

        const currentExt = String(current.ext).toLowerCase();
        const isWopiEnabled = ViewerSelectors.isWopiEnabled(state, currentExt) || current.id === EditorID.R7_WOPI;
        const editorConfig = enabledEditors.find((editor) => editor.id === current.id);
        const isChangeEditorPossible = AVAILABLE_PROVIDER_ID_MAP[current.id] && isWopiEnabled && editorConfig?.wopi;
        const editorData = await (isChangeEditorPossible ? getEditorData(item.id) : Promise.resolve(undefined));
        const astraMetaFeature = getAstraMetaFeature(state);
        const gaCategory = current.id === EditorID.R7 ? 'r7-edtr' : 'myoffice';

        if (isRebranding) {
            setRebranding();
        }

        let wopiData = editorData?.status === EditorStatus.Ready ? editorData.data : undefined;

        /**
         * Переопределяем текущий редактор.
         * Пользователь мог редактировать c помощью МойОфис,
         * а после у него включился эксперимент и основным стал редактор R7Wopi.
         *
         * Note. editorData.data может быть null (5хх ошибки) или EditorID (4хх ошибки). Переключение здесь только при EditorID
         */
        if (editorData?.status === EditorStatus.Error && editorData.data) {
            current.id = editorData.data;
        }

        const navigationStart = window.performance && performance.timing && performance.timing.navigationStart;
        const radarGroup = `editors-${current.id}`;
        const isEditorMyOffice = current.id === EditorID.MYOFFICE;
        const theme = isDarkThemeModeEnabled() ? R7Theme.dark : R7Theme.light;

        const editorCount = editor.getEditorsFor(item || current).length;

        const sendEpsilonTime = function (lable: string, time = 0) {
            if (DETAILED_RADARS) {
                // CLOUDWEB-7854
                if (arguments.length < 2) {
                    time = Date.now() - navigationStart;
                }

                // eslint-disable-next-line new-cap
                RADAR(`${radarGroup}_${lable}_time-${time > 60000 ? 'over1m' : epsilonTime(time)}`);
            }
        };

        const radar = RADAR.group(radarGroup);

        radar.add('open');
        radar.add(`open_${currentExt}`);
        sendEpsilonTime(`open_${currentExt}`);

        const currentEditorConfig =
            editorData?.status === EditorStatus.Error
                ? enabledEditors.find((editor) => [EditorID.R7_WOPI, EditorID.MYOFFICE].includes(editor.id))
                : enabledEditors.find((editor) => editor.id === current.id);

        let currentEditor = currentEditorConfig && OFFICE_EDITOR[current.id];
        let frameData = current.data;

        const editorWaiting = document.querySelector('#editor__waiting') as HTMLElement;

        if (isWopiEnabled && currentEditorConfig?.wopi) {
            try {
                if (!wopiData) {
                    wopiData = (await callWopiEditAPICall(item?.id, current.id)).data;
                }
                current.mode = editingRestricted ? EditorMode.VIEW : EditorMode.EDIT;
                const url = addParams(wopiData?.url, {
                    title: 'title',
                    lang: 'ru-ru',
                    thm: theme,
                    closebutton: 1,
                    revisionhistory: 1,
                    mobile: IS_MOBILE_BROWSER ? 1 : undefined,
                });

                frameData = {
                    ...wopiData,
                    [`${current.mode}_url`]: url,
                };
            } catch (error) {
                logger.error(error);
                captureException(error, { message: 'Editor wopi api error' });
            }
        }
        const isNeedForceAmrFallback = currentEditor && !wopiData && !editorData?.data;

        if ((!currentEditor || (!IS_PUBLIC && editorCount === 0)) && !isNeedForceAmrFallback) {
            radar.add('error').send();
            sendEpsilonTime('error');
            reduxStore.dispatch(routeStatusPage({ status: EStatus.NOT_FOUND }));
        } else if ((!frameData?.edit_url || (!frameData?.access_token && !isEditorMyOffice)) && !isNeedForceAmrFallback) {
            radar.add('error').send();
            sendEpsilonTime('error');
            reduxStore.dispatch(routeStatusPage({ status: EStatus.INTERNAL_SERVER_ERROR }));
        } else {
            const OfficeEditor = OFFICE_EDITOR[current.id];
            currentEditor = new OfficeEditor({
                mode: current.mode,
                editorId: current.id,
            });

            reduxStore.dispatch(
                startEditor({
                    editorId: current.id,
                    // @ts-ignore
                    item: !IS_PUBLIC ? clone(item) : undefined,
                })
            );

            const notifyMeta = reduxStore.dispatch(getNotificationAboutCreatingCopyOfNoneditableFile());
            const createdFileId = notifyMeta?.newId;
            const notifyFrom = notifyMeta?.from;
            const currentFileId = item?.id;
            const editAttachCopyText = editAttachCopyNotification.getText();
            const editCopyText = editPublicCopyNotification.getText();

            if (editCopyText) {
                snackbarController.showSnackbar({
                    id: 'clone-edit-notification',
                    closable: true,
                    text: editCopyText,
                    type: SnackbarTypes.success,
                    oneline: true,
                    closeTimeout: 5000,
                });
                editPublicCopyNotification.clear();
            }

            if (editAttachCopyText) {
                snackbarController.showSnackbar({
                    id: 'clone-edit-attach-notification',
                    closable: true,
                    text: editAttachCopyText,
                    type: SnackbarTypes.success,
                    closeTimeout: 5000,
                });
                editAttachCopyNotification.clear();
            }

            if (createdFileId && createdFileId === currentFileId) {
                const { buttonText, onButtonClick } = {
                    [NotifyFrom.home]: {
                        buttonText: 'Перейти к файлу',
                        onButtonClick: () =>
                            toolbarActions.showInParentFolder({
                                folderId: item?.parent ?? '',
                                itemId: currentFileId,
                            }),
                    },
                    [NotifyFrom.sharedHome]: {
                        buttonText: 'Настроить доступ',
                        onButtonClick: () => toolbarActions.publish('editor', currentFileId),
                    },
                }[notifyFrom];
                snackbarController.showSnackbar({
                    id: 'create-copy-of-non-editable-file-success',
                    closable: true,
                    text: 'Документ создан',
                    buttonText,
                    onButtonClick,
                    type: SnackbarTypes.success,
                    oneline: true,
                    closeTimeout: 5000,
                });
                reduxStore.dispatch(clearNotificationAboutCreatingCopyOfNoneditableFile());
            }

            const isLLMEnabled = LLM && isAvailableInDocumentSection(item?.ext) && SCENARIO_SELECT_OPTIONS.length;

            const llmButton = document.querySelector('#llm-button');
            const llmDialog = document.querySelector('#llm-dialog');

            if (isLLMEnabled && llmButton && llmDialog && !IS_B2B_BIZ_USER) {
                const reactLlmButton = new BReactComponent({
                    ReactComponent: EditorLLMButton,
                });

                const reactLlmDialog = new BReactComponent({
                    ReactComponent: EditorLlmDialog,
                });

                reactLlmButton.renderTo(llmButton, {
                    props: {
                        isWithText: llmFeature.hoverType === 'withText',
                    },
                });
                reactLlmDialog.renderTo(llmDialog, { props: {} });
            }

            const header = document.querySelector('#react-header');

            const headerType = isOnPremR7Product ? 'b2b' : 'b2c';

            const isR7 = current.id === EditorID.R7 || (isOnPremR7Product && current.id === EditorID.MYOFFICE);
            const isMobileR7 = isR7 && IS_MOBILE_BROWSER;
            const renderB2CHeader =
                !isMobileR7 && header && headerType === 'b2c' && [EditorID.MYOFFICE, EditorID.R7_WOPI].includes(current.id);
            const renderB2BHeader = !isMobileR7 && header && (headerType === 'b2b' || isR7);

            if (isMobileR7 && IS_MY_TEAM) {
                const bizInlineToolbar = new BReactComponent({
                    ReactComponent: MyTeamMobileEditorHeader,
                });

                bizInlineToolbar.renderTo(header, {
                    props: {
                        fileName: item.name,
                        subKind: item.subKind,
                    },
                });
            }

            if (renderB2BHeader) {
                const bizInlineToolbar = new BReactComponent({
                    ReactComponent: BizInlineEditorToolbar,
                });

                bizInlineToolbar.renderTo(header, {
                    props: {
                        isPublic: IS_PUBLIC,
                        gaCategory,
                        mode: current.mode,
                        file: item,
                    },
                });
            }

            if (renderB2CHeader) {
                const file = item as CloudFile;
                const isMyOfficeSendDetailRadars = getFeatureMyOfficeSendDetailRadars(state);

                if (isMyOfficeSendDetailRadars && (current.id === EditorID.MYOFFICE || currentEditorConfig?.wopi)) {
                    /** Проверка на флаг для моего офиса(моб/десктоп)
                     *
                     *  {@link https://jira.vk.team/browse/CLOUDWEB-13905 Задача}
                     */
                    const deviceType = !IS_MOBILE_BROWSER ? 'desktop' : 'mobile';
                    const viewerType = isWopiEnabled && currentEditorConfig?.wopi ? 'wopi' : 'amr';
                    const mode = 'edit';

                    /** Формат радара для моего офиса
                     *    @example Пример.
                     *    myoffice_open_<device_type>_<viewer_type>_<mode>_<ext>
                     */
                    xray.send(`myoffice_open_${deviceType}_${viewerType}_${mode}_${file?.ext}`);
                }

                startEditorSuccessWaiter(file, current.id, true);

                if (current.id !== EditorID.MYOFFICE) {
                    const documentBubble = Object.assign(new Promo(BUBBLE_ID), {
                        isEnabled() {
                            return isEnabledBubble;
                        },
                    });

                    if (!isEnabledBubble) {
                        promoController.register(1, documentBubble);
                    }

                    isEnabledBubble = true;
                }

                const isMounted = isMountedOrSharedFolder(state, item).isMounted || item.isThisOrParentMounted;

                if (inlineHeader.enable && current.id === EditorID.R7_WOPI) {
                    const inlineToolbar = new BReactComponent({
                        ReactComponent: InlineEditorToolbar,
                    });

                    inlineToolbar.renderTo(header, {
                        props: {
                            isPublic: IS_PUBLIC,
                            file,
                        },
                    });
                } else {
                    const reactHeader = new BReactComponent({
                        ReactComponent: EditorHeader,
                    });

                    reactHeader.renderTo(header, {
                        props: {
                            /**
                             * TODO Вернуть условие, когда появится новый дизайн промо, выключаем перед запуском раздела документов
                             *  https://jira.vk.team/browse/CLOUDWEB-16928
                             */
                            showBubble: false,
                            onBubbleShow: () => {
                                // @ts-ignore
                                promoController.markAsShown(BUBBLE_ID);
                            },
                            isPublic: IS_PUBLIC,
                            isStock: IS_STOCK,
                            enableFavorites: !IS_PUBLIC && !isMounted,
                            gaCategory,
                            downloadDropdownList: isEditorMyOffice ? getDownloadDropdownList(file.name, file?.ext) : null,
                            editorId: current.id,
                            file,
                        },
                    });
                }

                const hasParentMountedOrShared = hasParentMountedOrSharedFolder(state, [item]);

                if (IS_FREE_BIZ_SAAS_USER && !IS_PUBLIC && !hasParentMountedOrShared && item.weblinkAccessRights !== 'rw') {
                    renderBizPaidEditorDialog();
                    return;
                }

                if (current.id === EditorID.R7_WOPI) {
                    r7StageCB({
                        onError: () => {
                            editorContainer?.remove();
                            header?.remove();
                            llmButton?.remove();
                            llmDialog?.remove();
                            reduxStore.dispatch(routeStatusPage({ status: EStatus.SOMETHING_WRONG }));
                        },
                    });
                }

                if (IS_TABLET_BROWSER && file.kind === 'document') {
                    // eslint-disable-next-line new-cap
                    RADAR(`public-mobile_openrw_${file?.ext}`);

                    const reactDialog = new BReactComponent({
                        ReactComponent: MobileDialog,
                    });

                    const publicNotifyEl = document.querySelector('.js-react-public-notify');
                    if (publicNotifyEl) {
                        reactDialog.renderTo(publicNotifyEl, {
                            props: {
                                title: 'Редактирование недоступно в мобильном браузере',
                                text: 'Пожалуйста, откройте ссылку на вашем компьютере',
                                closableStateInside: true,
                                isTablet: true,
                                mod: 'mobileV1',
                            },
                        });
                    }
                }
            }

            if (astraMetaFeature && current.id) {
                createAstraMetaDiv({
                    processorType: AstraMetaProcessorType.editor,
                    processorIDsMap: astraMetaFeature,
                    editorID: current.id,
                    isWOPI: isWopiEnabled,
                    fileExt: currentExt,
                });
            }
            const sendInfo = (status: string, frameStartTime: number) => {
                if (navigationStart) {
                    const time = Date.now() - navigationStart;

                    radar.add('load', time);
                    radar.add(`${'load_'}${currentExt}`, time);
                    radar.add(`load_${status}`, time);
                    radar.add(`load_${status}_${currentExt}`, time);
                    sendEpsilonTime(`load_${status}_${currentExt}`, time);
                }

                const frameTime = Date.now() - frameStartTime;

                radar.add('frame-load', frameTime);
                radar.add(`${'frame-load_'}${currentExt}`, frameTime);
                radar.add(`frame-load_${status}`, frameTime);
                radar.add(`frame-load_${status}_${currentExt}`, frameTime);
                sendEpsilonTime(`frame-load_${status}_${currentExt}`, frameTime);

                try {
                    radar.send();
                } catch (_) {}
            };

            const frameStartTime = Date.now();

            addEditorMessageListener();

            let isEditorFailed;
            const editorContainer = document.querySelector('#editor-container');
            const isAttach = current.isAttach;
            const r7AttachesPath = item.id;
            const editorUrl =
                isR7 && isAttach
                    ? r7AttachesPath
                    : (await frameData?.get_view_url?.(item, EStorageType.public, undefined)) || frameData?.edit_url || frameData?.view_url;
            const params = {
                access_token: frameData?.access_token || '',
                access_token_ttl: frameData?.access_token_ttl || 0,
            };

            currentEditor
                .start(item, editorContainer, editorUrl, current.mode, params, isNeedForceAmrFallback)
                .fail(() => {
                    isEditorFailed = true;
                    // Не загрузился iframe с редактором,
                    // показываем пользователю Облачную ошибку.
                    sendInfo('error', frameStartTime);
                })
                .always(() => {
                    if (editorWaiting) {
                        editorWaiting.style.display = 'none';
                    }
                    if (!isEditorFailed && editorContainer instanceof HTMLElement) {
                        editorContainer.dataset.editorReady = 'true';
                    }
                });

            currentEditor
                .on('timeout', () => {
                    if (isEditorFailed) {
                        return;
                    }
                    // Событие iframe.load сработало, но в течение
                    // установленнного времени так и не пришло
                    // ни одного сообщения от редактора.
                    // Вероятно редактор показал какую-то ошибку.
                    sendInfo('error', frameStartTime);
                })
                .on('sharing', () => {
                    publishHelper({ item });
                })
                .on('start', () => {
                    emitAnalyticEvent(AnalyticEventNames.EDITOR_VIEWER_OPEN_CONTENT);
                    sendViewerDwh({
                        id_public: 'None',
                        source: 'home',
                        type_content: item?.kind,
                        // @ts-ignore
                        extension: item?.ext?.toLowerCase() || '',
                        action: 'open-content',
                        is_full_render: true,
                        is_edit: true,
                        // @ts-ignore
                        size_files: item.size,
                        platform,
                        desktop_r7: isDesktopR7App(),
                    });
                    if (!isEditorFailed) {
                        sendInfo('success', frameStartTime);
                    }
                })
                .on('error', () => {
                    editorContainer?.remove();
                    header?.remove();
                    llmButton?.remove();
                    llmDialog?.remove();
                    reduxStore.dispatch(routeStatusPage({ status: EStatus.SOMETHING_WRONG }));
                })
                .on('rename', (_: any, params: any) => {
                    const { newName } = params;

                    if (!newName) {
                        return;
                    }

                    const splitPathName = window.location.pathname.split('/');
                    const withoutFileName = splitPathName.slice(0, -1).join('/');
                    // в current.ext лежит оригинальное расширение до применения toLowerCase
                    const fullName = `${newName}.${current.ext}`;
                    const url = `${withoutFileName}/${fullName}`;
                    const title = `${fullName} / Облако Mail`;

                    window.history.replaceState(null, '', url);
                    document.title = title;
                });
        }
    },
};

async function openEditor(editorArg: any, item: any, newExt?: string | null, force?: boolean, fileName?: string) {
    const state = reduxStore.getState();

    const isCreate = !!newExt;
    const mode = isCreate ? 'create' : 'edit';
    const ext = item.ext2 || item.ext;
    const IS_WEBKIT = browser.isWebKit();
    const { isDomainAndEditRestricted } = getDomainRestrictionsForItems(item);

    const hasParentMountedOrShared = hasParentMountedOrSharedFolder(state, [item]);

    if (!editorArg) {
        snackbarController.showSnackbar({
            id: 'no-editor',
            closable: true,
            text: `Не удалось открыть на редактирование файл этого  формата`,
            type: SnackbarTypes.failure,
            closeTimeout: 5000,
        });

        return;
    }

    if (!force) {
        if (IS_FREE_B2B_BIZ_EDITORS_USER && !editorArg) {
            renderBizPaidEditorDialog();
            return;
        }

        const isSharedOrMountedState = isMountedOrSharedFolder(state, item);
        const isMounted = isSharedOrMountedState && isSharedOrMountedState.isMounted;
        const lastId = isSharedOrMountedState && isSharedOrMountedState.folderId;
        const isSharedOrMounted = isSharedOrMountedState && isSharedOrMountedState.is;
        const folder = lastId && getItemById(state, lastId);

        // @ts-ignore
        if (isMounted && folder && folder.isReadOnly) {
            renderMessageBox({
                dataQAId: 'document-edit-readonly-folder-dialog',
                title: `${isCreate ? 'Папка доступна' : 'Файл доступен'} только для просмотра`,
                renderContent: () =>
                    `Общая папка доступна вам только для просмотра. ${
                        isCreate ? 'Вы не можете создавать в ней файлы.' : 'Вы не можете редактировать содержащиеся в ней файлы.'
                    }`,
            });

            logEditorOpenError(editorArg.id, 'readonly');

            return;
        }

        if (
            !isCreate &&
            isSharedOrMounted &&
            !editorArg[X_IN_SHARED_FOLDER] &&
            !editorArg['x-skip-shared-folder-warning'] &&
            !getIsOpenDocumentWarning(HAS_SHARED_EDITOR)
        ) {
            renderOpenDocument({
                hasSharedEditor: HAS_SHARED_EDITOR,
                onSuccess: () => {
                    setIsOpenDocumentWarning(HAS_SHARED_EDITOR);
                    openEditor(editorArg, item, newExt, true);
                },
            });

            return;
        }
    }

    if (editorArg['x-counter']) {
        sendCounter(editorArg['x-counter']);
    }

    let tabName = createWindowName(editorArg.id, item);

    {
        // CLOUDWEB-5491, CLOUDWEB-5602, CLOUDWEB-5605, CLOUDWEB-5606
        if (isCreate) {
            // Открываем новую вкладку с редактором
            // для каждого нового документа.
            tabName += Date.now().toString(36);
        }

        // Chrome, Opera и Safari позволяют переключиться
        // на вкладку с редактором. IE включает мигание вкладки.
        tabs = tabs || {};
        const tab = tabs[tabName];

        if (tab) {
            // Для этого документа уже открывалась вкладка с редактором.
            if (isOpenedTab(tab)) {
                // Вкладка редактора для этого документа все еще открыта.
                // Просто переключаемся на вкладку с редактором
                // и завершаем дальнейшее выполнение openEditor.
                tab.focus();

                if (!IS_WEBKIT) {
                    // В IE включится мигание вкладки, по переключение
                    // не произойдет. Firefox вообще никак не отрегаирует.
                    // Поэтому показываем пользователю bubble.
                    const message = 'Документ «{NAME}» уже открыт для редактирования.'.replace(
                        '{NAME}',
                        shortenFilename(item, 60).split('').join('\u200B')
                    ); // TODO: use b-filename

                    const isViewerVisible = ViewerSelectors.isViewerActive(reduxStore.getState());
                    if (!isViewerVisible) {
                        snackbarController.showSnackbar({
                            id: 'error',
                            text: message,
                            type: SnackbarTypes.failure,
                            closable: true,
                        });
                    }
                }

                return;
            }
            // Вкладка редактора для этого документа уже закрыта,
            // удаляем ненужную сслыку на старый инстанс Window.
            delete tabs[tabName];
        }
    }

    const openTab = editorArg['x-open-popup'] ? openPopup : _openTab;

    // RADAR.ga('send', 'event', 'open_for_' + mode, newExt || item.ext, editorArg.id.toLowerCase());

    const radar = RADAR.group(`app_edit-${editorArg.id.toLowerCase()}`);

    radar.add(mode);
    radar.add(`${mode}_${newExt || item.ext}`);
    radar.send();

    if (editorArg.id !== EditorID.R7 && editorArg.id !== EditorID.MYOFFICE) {
        startEditorSuccessWaiter(item, editorArg.id, false);
    }

    const processApiError = (errors) => {
        openTab('/500', tabName);

        logEditorOpenError(editorArg.id, 'apierror');

        reduxStore.dispatch(makeNewDocumentError());

        captureException(errors, {
            message: 'EDITOR ERROR',
            item,
            errors,
        });
    };

    const promise = new Promise((resolve, reject) => {
        const convertExt = editorArg.convert_extensions[ext];
        if (editorArg.id === EditorID.R7 && convertExt) {
            renderComfirmationDialog({
                dataQAId: 'document-convert-confirmation-dialog',
                renderContent: () =>
                    `Формат файла не поддерживается. Создать копию в поддерживаемом формате ${convertExt} и начать редактирование?`,
                onSuccess: () => {
                    // TODO: где-то тут надо будет потом доработать от продукта
                    // что делать и как проверять, что файл уже существует,
                    // нужно ли спрашивать юзера про новое имя и тп
                    callApiR7Convert(item.id)
                        .then(({ data }) => {
                            resolve({ id: data.path, storage: item.storage, ext: convertExt });
                        })
                        .catch((err) => {
                            snackbarController.showSnackbar({
                                id: 'document-convert-error',
                                type: SnackbarTypes.failure,
                                text: `Не удалось сконвертировать документ: ${err}`,
                                closable: true,
                            });
                            reject();
                        });
                },
                onClose: () => reject(),
            });
        } else {
            // @ts-ignore
            resolve();
        }
    });

    const newItem = await promise;

    const { action, isFromExternal } = SettingsSelectors.getQueryParams(state);
    const isCreateDocumentByQueryParam = isCreateDocumentQueryAction(action);

    if (!IS_MY_TEAM && !isCreateDocumentByQueryParam /* CLOUDWEB-14757: не нужно что бы открывался таб */) {
        openTab('about:blank', tabName);
    }

    // после конвертации редактор по-умолчанию может измениться
    if (newItem) {
        const editorId = editor.getDefaultEditorId(newItem, false);
        editorArg = editorId && editorsMap[editorId];
    }

    const url = await getV2orUniqueIdUrl({ item: newItem || item, newExt, hasParentMountedOrShared, editorArg });

    let tab: any = null;

    if (editorArg?.id === EditorID.R7) {
        const location = isCreate ? 'create' : item?.storage?.replaceAll('/', '-');
        xray.send(`open-r7-from_${location}`);
    }

    // CLOUDWEB-5491, CLOUDWEB-5602, CLOUDWEB-5605, CLOUDWEB-5606
    if (isCreate) {
        try {
            const { data = '' } = await callApiCreateDoc(url, newExt, fileName);

            const itemId = IS_B2B_BIZ_USER ? data.path : joinPath(item.id, data.name);
            const createdItem = { id: itemId, home: itemId, ext: newExt };
            const openUrl = isDomainAndEditRestricted
                ? getCloudUrl({
                      item: createdItem,
                      token: null,
                  })
                : await getV2orUniqueIdUrl({ item: createdItem, newExt: null, hasParentMountedOrShared, editorArg, isCreate });

            const name = IS_MY_TEAM ? '_self' : tabName;

            if (!isCreateDocumentByQueryParam /* CLOUDWEB-14757: не нужно что бы открывался таб */) {
                if (isEnabledMultiWindow()) {
                    openNewWindow(openUrl);
                    const currentRouteId = getCurrentRouteId(state);
                    reduxStore.dispatch(checkFolderForUpdate(currentRouteId));
                } else {
                    tab = openTab(openUrl, name);
                }
            } else {
                /* Не энкодим, потому что доверяем getUrlV2 */
                window.location.href = isFromExternal ? `${openUrl}?isFromExternal=true` : openUrl;
            }

            reduxStore.dispatch(makeNewDocumentSuccess());
        } catch (error: any) {
            processApiError(error);
        }
    } else if (IS_MY_TEAM) {
        const fullUrl = new URL(url, window.location.origin);
        fullUrl.searchParams.set('wv', '1');

        if (isEnabledMultiWindow()) {
            openNewWindow(fullUrl.href);
        } else {
            window.open(fullUrl.href, '_self');
        }
    } else {
        // Chrome, Opera и Safari позволяют переключиться
        // на вкладку с редактором, а IE включает мигание
        // вкладки, для этого запоминаем ссылку
        // на соответствующий инстанс Window.
        tab = openTab(url, tabName);

        startTabGC();
    }

    if (tab) {
        tabs[tabName] = tab;
    }
}

export { editor };
